import { createFileRoute } from "@tanstack/react-router";

import { OverviewTab } from "@/features/billing";

export const Route = createFileRoute(
  "/_auth/_app-shell/billing/$projectId/overview",
)({
  component: OverviewTab,
});
